import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Podiatrist icon
 *
 * @category Medical
 */
const Podiatrist = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M26.68 22.75s-.06-.03-.09-.04c-1.25-.59-2.55-1.08-3.79-1.7-2.46-1.23-4.81-2.72-6.77-4.65-.23-.22-.45-.46-.6-.75-.13-.26-.19-.56-.23-.85-.49-3.18.24-6.46-.23-9.64-.03-.19-.09-.42-.27-.49-.17-.06-.35.05-.44.21s-.09.34-.1.52l-.12 3.82c-.05 1.65-.1 3.3.04 4.94.08.94.23 1.91.8 2.69s1.49 1.35 2.26 1.96c1.83 1.44 3.83 2.71 6.01 3.56 1.15.45 2.91.77 3.41 2.07.29.75-.29 1.16-.93 1.39-1.73.61-3.24.67-5.03.56-.38-.02-1.28-.07-1.66-.11-1.53-.16-3.24-.53-4.78-.45-2.18.11-6.04.96-7.06-1.74-.53-1.41-.24-2.94.04-4.36.45-2.24.43-4.57.45-6.84.03-2.41 0-4.81-.08-7.22 0-.3-.03-.61-.19-.86-.05-.07-.11-.14-.19-.16-.28-.1-.46.3-.49.6-.37 3.81.08 7.64-.12 11.46-.09 1.76-.54 3.44-.7 5.18-.14 1.54.13 3.05 1.31 4.14 2.45 2.16 6.07.21 8.85.72 2.67.53 5.73.57 8.31.45 1.31-.04 2.99-.25 3.48-1.67.39-1.08-.13-2.2-1.11-2.72z"
        />
        <path
          fill="currentColor"
          d="M8.5 23.63s.04.06.07.09c.4.52 1.08.75 1.73.78s1.3-.11 1.95-.18c2.44-.28 4.87.3 7.31.6 1.39.17 2.83.25 4.17-.14.41-.12.89-.41.83-.83-.05-.3-.36-.48-.63-.61-2.51-1.21-5.02-2.43-7.54-3.64-1.14-.55-2.33-1.14-3.03-2.19-.85-1.28-.79-2.93-.73-4.47.1-2.66.1-5.31 0-7.97 0-.2-.03-.42-.19-.53-.19-.13-.46-.01-.58.18s-.13.43-.13.66c-.05 2.03-.09 4.06-.14 6.08-.05 2.21-.09 4.49.72 6.55.16.41.36.85.23 1.26-.2.65-1.03.82-1.71.88-.41.03-.88.05-1.15-.26-.25-.27-.22-.68-.19-1.05.41-4.42.53-8.87.35-13.3-.02-.43-.32-1.57-.82-.83-.38.56-.35 1.34-.32 1.99.14 3.08.18 6.16-.1 9.23-.18 1.99-.49 3.97-.47 5.97 0 .59.05 1.22.38 1.71zm1.18-2.26c1.25-.14 2.8-.76 3.84-1.57.36-.19.64-.23 1-.09 1.31.61 4.88 2.47 7.01 3.52.83.43 1.42.64.41.67-.73.01-1.63.02-2.39 0-2.09.06-3.94-1.11-6.13-.84-1.27.06-2.79.86-3.94.06-.64-.49-.59-1.45.04-1.69l.14-.06z"
        />
      </svg>
    );
  }
);

Podiatrist.displayName = 'Podiatrist';

export { Podiatrist };
